import { useEffect } from "react";
import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  LinkButton,
} from "../components/ui";
import { useSeo } from "../lib/seo";

export function NotFound() {
  useSeo({
    title: "Page not found — WeConsult Rx",
    description: "The page you’re looking for doesn’t exist.",
    path: "/404",
    noIndex: true,
  });

  // Best-effort status hint for static hosts that read meta http-equiv.
  useEffect(() => {
    document.documentElement.dataset.notfound = "true";
  }, []);

  return (
    <Section className="text-center">
      <Container>
        <Eyebrow>404</Eyebrow>
        <Heading level={1} className="mt-3">
          We couldn’t find that page.
        </Heading>
        <Lede className="mt-6 mx-auto">
          The page may have moved or never existed. Try one of the links below.
        </Lede>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <LinkButton to="/">Go home</LinkButton>
          <LinkButton to="/platform" variant="secondary">Platform</LinkButton>
          <LinkButton to="/contact" variant="secondary">Contact us</LinkButton>
          <LinkButton to="/sitemap" variant="ghost">View sitemap</LinkButton>
        </div>
      </Container>
    </Section>
  );
}
